@if(loader.loading()){
<div class="loader-backdrop">
    <div class="spinner"></div>
</div>
}